import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import Placeholder from 'react-bootstrap/Placeholder';
import { BsThreeDotsVertical, BsPersonCircle, BsCloudSlashFill, BsSafe } from "react-icons/bs";
import { MdModeEdit, MdVisibility, MdDelete, MdGrid3X3, MdCircle, MdLocationOn } from "react-icons/md";
import { FaDatabase, FaCalendar } from "react-icons/fa";
import "../../../DataCollection/style.css";
import tasksAPI from "../../../../api/tasks";
import { Link, useNavigate } from "react-router-dom";
import style from "./Tasks.module.scss";
import { TaskService } from "../../../../HttpService/TaskService";
import AuthContext from "../../../../auth/authContext";
import { tabFormName } from "../../../../.config";
import { TODIS_BTN_SECUNDARY, TODIS_SECONDARY_BTN } from "../../../../components/Buttons";
import download from "../../../../assets/icons/download.svg";
import { TODIS_MODAL_DATACOLLECTION } from "../../../../components/Modals/ModalDatacollecction";
import { HttpService } from '../../../../HttpService/HttpService';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';

const IMPORT_DATE_FIELDS = new Set([
    'tenderStartDateInitFore',
    'tenderStartDateCurrEst',
    'tenderStartDateActual',
    'designCompDateFore',
    'designCompDateCurrEst',
    'designCompDateActual',
    'projCompDateFore',
    'projCompDateCurrEst'
]);

const LOCKED_EXPORT_FIELDS = new Set([
    'TaskId',
    'liveRwProjId',
    'regionalPartner',
    'routeId',
    'startNodeName',
    'endNodeName',
    'startKm',
    'endKm',
    'dateValidFrom',
    'dateValidTo',
    'dateValidFor'
]);

const ROOT_IMPORT_FIELDS = new Set([
    'npmRoadId'
]);

// const IMPORT_DEBUG_PREFIX = '[IMPORT_DEBUG]';

const excelSerialToIsoDate = (serial) => {
    if (typeof serial !== 'number' || Number.isNaN(serial)) return serial;

    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const date = new Date(utcValue * 1000);

    if (Number.isNaN(date.getTime())) return serial;
    return date.toISOString().slice(0, 10);
};

const normalizeImportedDateValue = (fieldName, rawValue) => {
    if (!IMPORT_DATE_FIELDS.has(fieldName)) {
        return rawValue ?? null;
    }

    if (rawValue === null || rawValue === undefined || rawValue === '') {
        return null;
    }

    if (typeof rawValue === 'number') {
        return excelSerialToIsoDate(rawValue);
    }

    if (rawValue instanceof Date) {
        return rawValue.toISOString().slice(0, 10);
    }

    if (typeof rawValue === 'string') {
        const value = rawValue.trim();
        const dmyMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

        if (dmyMatch) {
            const [, day, month, year] = dmyMatch;
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }

        const parsed = new Date(value);
        if (!Number.isNaN(parsed.getTime())) {
            return parsed.toISOString().slice(0, 10);
        }
    }

    return rawValue;
};

const Tasks = ({ permissions }) => {
    const [NombreArchivo, setNombreArchivo] = useState("exported_data.xlsx");
    const [uploadedFile, setUploadedFile] = useState(null); // Estado para almacenar el archivo cargado
    const [jsonData, setJsonData] = useState(null); // Estado para almacenar el JSON generado

    function getProjectTitle(transportType, regionalPartner, projectType) {
        const transportTypeTranslations = {
            'Roads': 'Road',
            'Railways': 'Railway',
            'Inland waterways': 'Inland Waterway',
            'Airports': 'Airport',
            'Railways Border Crossings': 'Railway Border Crossing',
            'Roads Border crossing': 'Road Border Crossing',
            'Seaports': 'Seaport',
            'Inland waterway ports': 'Inland Waterway Port'
        };

        if (transportType === 'Roads' || transportType === 'Railways' || transportType === 'Inland waterways') {
            if (projectType === 'TEN-T Projects') {
                return `${getSingularTransportType(transportType)} Project in ${regionalPartner}`;
            } else if (projectType === 'TEN-T Network performance monitoring') {
                return `${getSingularTransportType(transportType)} Section in ${regionalPartner}`;
            }
        } else if (projectType === 'EU Acquis') {
            return `${projectType} in ${regionalPartner}`;
        } else if (
            (transportType === 'Airports' || transportType === 'Seaports' || transportType === 'Inland waterway ports' || transportType == 'Freight Terminals') && projectType === 'TEN-T Projects') {
            return `${getSingularTransportType(transportType)} Project in ${regionalPartner}`;
        } else {
            return `${getSingularTransportType(transportType)} in ${regionalPartner}`;
        }

        function getSingularTransportType(type) {
            return transportTypeTranslations[type] || type;
        }
    }



    const navigate = useNavigate();
    const { user } = useContext(AuthContext);

    const [response, setResponse] = useState(false)
    const [tasksPending, setTasksPending] = useState([])
    const [tasksWorking, setTasksWorking] = useState([])
    const [tasksDone, setTasksDone] = useState([])
    const [tasksNotFound, setTasksNotFound] = useState(false)
    const [taskId, setTaskId] = useState(sessionStorage.getItem('taskId'));
    const scrollRef = useRef(null);
    const [modalShow, setModalShow] = useState(false);
    const [modalExportShow, setModalExportShow] = useState(false);

    // Estado para el filtro de fecha
    const [filterDate, setFilterDate] = useState('');

    // Estado que contendrá todos los IDs seleccionados
    const [selectedTaskIds, setSelectedTaskIds] = useState([]);
    const [selectedRequestIds, setSelectedRequestIds] = useState([]);
    const [selectedTasks, setSelectedTasks] = useState([]);

    // IDs de cada categoría
    const allPendingIds = tasksPending.map(t => t.id);
    const allWorkingIds = tasksWorking.map(t => t.id);
    //const allDoneIds = tasksDone.map(t => t.id);

    // Seleccionar TODAS las tareas
    const handleSelectAll = () => {
        const allTasks = [
            ...tasksPending.map(task => ({ taskId: task.id, requestId: task.requestId })),
            ...tasksWorking.map(task => ({ taskId: task.id, requestId: task.requestId })),
            //...tasksDone.map(task => ({ taskId: task.id, requestId: task.requestId })),
        ];
        setSelectedTasks(allTasks);
    };

    // Deseleccionar TODAS las tareas
    const handleDeselectAll = () => {
        setSelectedTasks([]);
    };

    // Seleccionar todas las Pending
    const handleSelectAllPending = () => {
        const pendingTasks = tasksPending.map(task => ({ taskId: task.id, requestId: task.requestId }));
        setSelectedTasks(prev => [...prev, ...pendingTasks]);
    };

    // Deseleccionar todas las Pending
    const handleDeselectAllPending = () => {
        setSelectedTasks(prev => prev.filter(task => !tasksPending.some(pending => pending.id === task.taskId)));
    };

    // Seleccionar todas las Working
    const handleSelectAllWorking = () => {
        const workingTasks = tasksWorking.map(task => ({ taskId: task.id, requestId: task.requestId }));
        setSelectedTasks(prev => [...prev, ...workingTasks]);
    };

    // Deseleccionar todas las Working
    const handleDeselectAllWorking = () => {
        setSelectedTasks(prev => prev.filter(task => !tasksWorking.some(working => working.id === task.taskId)));
    };

    // Seleccionar todas las Done
    // const handleSelectAllDone = () => {
    //     const doneTasks = tasksDone.map(task => ({ taskId: task.id, requestId: task.requestId }));
    //     setSelectedTasks(prev => [...prev, ...doneTasks]);
    // };

    // // Deseleccionar todas las Done
    // const handleDeselectAllDone = () => {
    //     setSelectedTasks(prev => prev.filter(task => !tasksDone.some(done => done.id === task.taskId)));
    // };

    // Seleccionar TODOS los requestIds
    const handleSelectAllRequests = () => {
        const allRequestIds = [
            ...tasksPending.map(t => t.requestId),
            ...tasksWorking.map(t => t.requestId),
            //...tasksDone.map(t => t.requestId),
        ];
        setSelectedRequestIds(prev => Array.from(new Set([...prev, ...allRequestIds])));
    };

    // Deseleccionar TODOS los requestIds
    const handleDeselectAllRequests = () => {
        setSelectedRequestIds([]);
    };

    // Manejar el cambio de estado de los checkboxes para requestIds
    const handleRequestCheckboxChange = (requestId) => {
        setSelectedRequestIds(prevSelected => {
            if (prevSelected.includes(requestId)) {
                return prevSelected.filter(id => id !== requestId);
            } else {
                return [...prevSelected, requestId];
            }
        });
    };

    useEffect(() => {
        (async () => {
            setTimeout(async () => {
                let res = await new TaskService("workflow/tasks/" + user.username).getTasks();
                console.log("These are the values of a task", res);
                if (res) {
                    setTasksPending(prevState => {
                        return res.tasks.PENDING.sort(function (x, y) {
                            return y.id - x.id;
                        });
                    })
                    setTasksWorking(prevState => {
                        return res.tasks.WORKINGON.sort(function (x, y) {
                            return y.id - x.id;
                        });
                    });
                    setTasksDone(prevState => {
                        return res.tasks.DONE.sort(function (x, y) {
                            return y.id - x.id;
                        });
                    });
                    setResponse(true);
                    if (taskId !== null && scrollRef.current !== null) {
                        scrollRef.current.scrollIntoView({ behavior: 'smooth' });
                    }
                } else {
                    setTasksNotFound(true);
                    setResponse(true);
                }
            }, 500)
        })();
    }, [taskId]);

    const resetTaskId = () => {
        setTaskId(null);
        sessionStorage.setItem('taskId', null);
    };

    // Maneja el cambio de estado de los checkboxes.
    const handleCheckboxChange = (taskId, requestId) => {
        setSelectedTasks(prevSelected => {
            const exists = prevSelected.some(pair => pair.taskId === taskId && pair.requestId === requestId);
            if (exists) {
                // Si ya existe, lo eliminamos
                return prevSelected.filter(pair => pair.taskId !== taskId || pair.requestId !== requestId);
            } else {
                // Si no existe, lo agregamos
                return [...prevSelected, { taskId, requestId }];
            }
        });
    };

    const changeWorkingOn = async (task) => {
        try {
            let url = "workflow/update";
            let body;
            if (permissions.some(item => item.id == 2)) {
                // url = "workflow/update/" + task.requestId + "/" + task.id + "/PENDING/ADMIN/" + user.username;
                body = { requestId: task.requestId, taskId: task.id, taskStatus: "PENDING", userRole: "ADMIN", assignUserId: user.username, comment: "" };
            } else if (permissions.some(item => item.id == 5)) {
                // url = "workflow/update/" + task.requestId + "/" + task.id + "/PENDING/COORDINATOR/" + + user.username;
                body = { requestId: task.requestId, taskId: task.id, taskStatus: "PENDING", userRole: "COORDINATOR", assignUserId: user.username, comment: "" }
            } else if (permissions.some(item => item.id == 3)) {
                // url = "workflow/update/" + task.requestId + "/" + task.id + "/PENDING/REGIONALUSER/" + user.username;
                body = { requestId: task.requestId, taskId: task.id, taskStatus: "PENDING", userRole: "REGIONALUSER", assignUserId: user.username, comment: "" }
            }
            let res = await new TaskService(url).changeStatus(body);

            if (res.status == 200) {
                navigate("/TODIS-APP/WorkFlow/task/" + task.id, { state: "new" })
            } else {
                alert("Error when changing state")
            }

        } catch (error) {
            console.log(error)
        }
    }
    const handleDownloadTemplateClick = () => {
        // Ruta del archivo Excel que se encuentra en la carpeta `public`
        const templateUrl = "/templates/import_template.xlsx";
        const link = document.createElement("a");
        link.href = templateUrl;
        link.download = "import_template.xlsx"; // Nombre del archivo al descargar
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const getExportFileName = ({ module = "Export" }) => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');

        const date = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}`;
        const time = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

        return `${module}_${date}_${time}`;
    };

    const handleExportDataClick = async () => {
        const transformedTasks = selectedTasks.map(pair => [pair.taskId, pair.requestId]);
        const requestBody = {
            tasks: transformedTasks, // Enviar los datos transformados
        };

        console.log("Datos que se enviarán al backend:", JSON.stringify(requestBody));

        // Mostrar el mensaje de carga
        const loadingSwalTimeout = setTimeout(() => {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                showCancelButton: true,
                cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }, 5);

        try {
            const response = await new HttpService('workflow/tasks/export').post(requestBody);

            // Cerrar el mensaje de carga
            clearTimeout(loadingSwalTimeout);
            Swal.close();

            if (!response || !response.data) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No response from server.'
                });
                return;
            }

            console.log("Response from backend:", response.data);

            // Extraer los datos relevantes del JSON
            const jsonData = response.data.data;

            // Verificar si hay tareas que no se pudieron exportar
            if (!response.data.success) {
                const notExportedIds = response.data.data.notExportedInformation || [];
                Swal.fire({
                    icon: 'warning',
                    title: 'Export Error',
                    html: `
                        <p>Some tasks could not be exported:</p>
                        <div style="max-height: 300px; overflow-y: auto; text-align: left; padding: 10px;">
                            <ul>
                                ${notExportedIds.map(id => `Task ID: ${id}<br>`).join('')}
                            </ul>
                        </div>
                    `
                });
            }

            // Crear un libro de Excel
            const workbook = new ExcelJS.Workbook();

            // Iterar sobre las claves del objeto JSON, excluyendo "notExportedInformation"
            for (const key of Object.keys(jsonData)) {
                if (key === "notExportedInformation") continue; // Excluir esta clave

                const tasks = jsonData[key];
                if (tasks.length > 0) { // Solo crear pestañas para claves con datos
                    const flatData = tasks.map((task) => {
                        const taskId = Object.keys(task)[0];
                        const taskDetails = task[taskId];

                        // Aplanar tablas anidadas sin conservar la columna "objeto crudo"
                        const flattenedDetails = { TaskId: taskId };

                        Object.keys(taskDetails).forEach((detailKey) => {
                            const detailValue = taskDetails[detailKey];

                            if (detailValue && typeof detailValue === 'object' && !Array.isArray(detailValue)) {
                                Object.keys(detailValue).forEach((subField) => {
                                    flattenedDetails[`${detailKey}_${subField}`] = detailValue[subField];
                                });
                            } else {
                                flattenedDetails[detailKey] = detailValue;
                            }
                        });

                        return flattenedDetails;
                    });

                    // Crear cabeceras agrupadas
                    const headers = {};
                    const subHeaders = {};
                    const merges = [];

                    // Generar las cabeceras y subcabeceras
                    let colIndex = 0;
                    flatData.forEach((row) => {
                        Object.keys(row).forEach((key) => {
                            const [group, field] = key.split('_');
                            if (field) {
                                headers[key] = group; // Primera fila: grupo
                                subHeaders[key] = field; // Segunda fila: atributo
                            } else {
                                headers[key] = ''; // Sin grupo
                                subHeaders[key] = key; // Atributo directo
                            }
                        });
                    });

                    // Crear la hoja de Excel con cabeceras agrupadas
                    const headerRow = Object.values(headers);
                    const subHeaderRow = Object.values(subHeaders);
                    const dataRows = flatData.map((row) => Object.values(row));
                    const worksheetData = [headerRow, subHeaderRow, ...dataRows];

                    const worksheet = workbook.addWorksheet(key.slice(0, 31));
                    worksheet.addRows(worksheetData);

                    // Generar merges para las cabeceras agrupadas
                    let currentGroup = null;
                    let startCol = 0;

                    headerRow.forEach((group, index) => {
                        if (group !== currentGroup) {
                            if (currentGroup !== null) {
                                merges.push({ s: { r: 0, c: startCol }, e: { r: 0, c: index - 1 } });
                            }
                            currentGroup = group;
                            startCol = index;
                        }
                    });

                    // Agregar el último merge
                    if (currentGroup !== null) {
                        merges.push({ s: { r: 0, c: startCol }, e: { r: 0, c: headerRow.length - 1 } });
                    }

                    merges.forEach((mergeRange) => {
                        worksheet.mergeCells(
                            mergeRange.s.r + 1,
                            mergeRange.s.c + 1,
                            mergeRange.e.r + 1,
                            mergeRange.e.c + 1
                        );
                    });

                    // Aplicar estilos centrados a las cabeceras (primera y segunda fila)
                    [1, 2].forEach((rowNumber) => {
                        const row = worksheet.getRow(rowNumber);
                        row.eachCell((cell) => {
                            cell.alignment = {
                                horizontal: 'center',
                                vertical: 'middle',
                            };
                            cell.font = {
                                bold: true,
                            };
                        });
                    });

                    // Ajustar automáticamente el ancho de las columnas
                    const columnWidths = headerRow.map((_, colIndex) => Math.max(
                        ...worksheetData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 0))
                    ));

                    worksheet.columns = columnWidths.map((width) => ({
                        width: Math.min(Math.max(width + 2, 12), 60)
                    }));

                    // Dejar editables todas las celdas de datos y bloquear solo los campos indicados
                    const lockedColumnIndexes = subHeaderRow
                        .map((fieldName, index) => ({ fieldName, columnIndex: index + 1 }))
                        .filter(({ fieldName }) => LOCKED_EXPORT_FIELDS.has(String(fieldName).trim()))
                        .map(({ columnIndex }) => columnIndex);

                    for (let rowNumber = 3; rowNumber <= worksheet.rowCount; rowNumber += 1) {
                        for (let colNumber = 1; colNumber <= subHeaderRow.length; colNumber += 1) {
                            worksheet.getCell(rowNumber, colNumber).protection = { locked: false };
                        }

                        lockedColumnIndexes.forEach((colNumber) => {
                            worksheet.getCell(rowNumber, colNumber).protection = { locked: true };
                        });
                    }

                    await worksheet.protect('todis-export-lock', {
                        selectLockedCells: true,
                        selectUnlockedCells: true,
                    });
                }
            }

            // Si no hay datos exportados, no generar el archivo
            if (workbook.worksheets.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'No Data',
                    text: 'No tasks were successfully exported.'
                });
                return;
            }

            // Generar el archivo Excel
            const excelBuffer = await workbook.xlsx.writeBuffer();

            // Crear un Blob y descargar el archivo
            const blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = getExportFileName({ module: "Export" }) + ".xlsx"; // Nombre del archivo
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            // Cerrar el mensaje de carga en caso de error
            clearTimeout(loadingSwalTimeout);
            Swal.close();

            console.error("Error al exportar los datos:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error exporting data. Please try again.'
            });
        }
    };

    const handleImportExcel = async (file) => {
        try {
            /* console.log(`${IMPORT_DEBUG_PREFIX} handleImportExcel:start`, {
                name: file?.name,
                size: file?.size,
                type: file?.type,
                lastModified: file?.lastModified
            }); */

            const reader = new FileReader();

            reader.onload = async (e) => {
                try {
                    const fileBuffer = e.target?.result;

                    if (!fileBuffer) {
                        throw new Error('Invalid file buffer');
                    }

                    /* console.log(`${IMPORT_DEBUG_PREFIX} fileBuffer:ready`, {
                        byteLength: fileBuffer?.byteLength
                    }); */

                    const jsonData = {
                        data: {
                            airportsNpmTasks: [],
                            airportsLivePmTasks: [],
                            freightsLivePmTasks: [],
                            freightsNpmTasks: [],
                            iwwsLivePmTasks: [],
                            iwwsNpmTasks: [],
                            iwwPortsLivePmTasks: [],
                            iwwPortsNpmTasks: [],
                            seaportsLivePmTasks: [],
                            seaportsNpmTasks: [],
                            railwaysLivePmTasks: [],
                            railwaysNpmTasks: [],
                            roadsLivePmTasks: [],
                            roadsNpmTasks: [],
                            notExportedInformation: []
                        }
                    };

                    const normalizeCellValue = (cellValue) => {
                        if (cellValue === null || cellValue === undefined) return '';

                        if (typeof cellValue === 'object') {
                            if (cellValue instanceof Date) return cellValue;
                            if (cellValue.text !== undefined) return cellValue.text;
                            if (cellValue.result !== undefined) return cellValue.result;
                            if (Array.isArray(cellValue.richText)) {
                                return cellValue.richText.map((part) => part.text || '').join('');
                            }
                            if (cellValue.hyperlink) return cellValue.text || cellValue.hyperlink;
                        }

                        return cellValue;
                    };

                    const getRowValues = (worksheet, rowNumber, maxColumns) => {
                        const row = worksheet.getRow(rowNumber);
                        const values = [];

                        for (let col = 1; col <= maxColumns; col += 1) {
                            values.push(normalizeCellValue(row.getCell(col).value));
                        }

                        return values;
                    };

                    const processSheetRows = (sheetName, rows) => {
                        if (!rows || rows.length <= 2) {
                            /* console.log(`${IMPORT_DEBUG_PREFIX} sheet:skipped`, {
                                sheetName,
                                reason: 'rows<=2-or-empty',
                                rowsLength: rows?.length || 0
                            }); */
                            return;
                        }

                        const categories = rows[0] || [];
                        const headers = rows[1] || [];
                        const dataRows = rows.slice(2);

                        // Resolver categorias por columna con "forward-fill" para soportar celdas combinadas en cabeceras.
                        const resolvedCategories = [];
                        let currentCategory = '';
                        headers.forEach((header, index) => {
                            const normalizedHeader = String(header || '').trim();
                            const normalizedCategory = String(categories[index] || '').trim();

                            if (normalizedCategory) {
                                currentCategory = normalizedCategory;
                            }

                            // Si no hay header real, no tiene sentido propagar categoria.
                            if (!normalizedHeader) {
                                resolvedCategories[index] = '';
                                return;
                            }

                            resolvedCategories[index] = currentCategory;
                        });

                        const sheetData = dataRows.map((row) => {
                            const taskObject = {};
                            let taskId = null;

                            headers.forEach((header, index) => {
                                const normalizedHeader = String(header || '').trim();
                                if (!normalizedHeader) return;

                                const category = String(categories[index] || '').trim();
                                const effectiveCategory = normalizedHeader === "TaskId"
                                    ? ''
                                    : String(resolvedCategories[index] || category || '').trim();

                                const value = normalizeImportedDateValue(normalizedHeader, row[index]);

                                if (normalizedHeader === "TaskId") {
                                    taskId = value;
                                } else if (ROOT_IMPORT_FIELDS.has(normalizedHeader)) {
                                    if (value !== null && value !== undefined && value !== '') {
                                        taskObject[normalizedHeader] = value;
                                    }
                                } else if (effectiveCategory) {
                                    if (!taskObject[effectiveCategory] || typeof taskObject[effectiveCategory] !== 'object' || Array.isArray(taskObject[effectiveCategory])) {
                                        let normalizedCategoryObject = {};

                                        if (typeof taskObject[effectiveCategory] === 'string') {
                                            const rawCategoryValue = taskObject[effectiveCategory].trim();
                                            if (rawCategoryValue.startsWith('{') && rawCategoryValue.endsWith('}')) {
                                                try {
                                                    const parsedCategory = JSON.parse(rawCategoryValue);
                                                    if (parsedCategory && typeof parsedCategory === 'object' && !Array.isArray(parsedCategory)) {
                                                        normalizedCategoryObject = parsedCategory;
                                                    }
                                                } catch (parseCategoryError) {
                                                    /* console.warn(`${IMPORT_DEBUG_PREFIX} category:json-parse-failed`, {
                                                        category: effectiveCategory,
                                                        valuePreview: rawCategoryValue.slice(0, 120)
                                                    }); */
                                                }
                                            }
                                        }

                                        taskObject[effectiveCategory] = normalizedCategoryObject;
                                    }

                                    // Si ya existe en raiz, lo removemos para evitar duplicado root/subtabla.
                                    if (Object.prototype.hasOwnProperty.call(taskObject, normalizedHeader)) {
                                        delete taskObject[normalizedHeader];
                                    }
                                    taskObject[effectiveCategory][normalizedHeader] = value;
                                } else {
                                    taskObject[normalizedHeader] = value;
                                }
                            });

                            // Seguridad adicional: si algun campo quedo duplicado en raiz y subtabla, remover el de raiz.
                            const rootKeys = Object.keys(taskObject).filter((key) => {
                                const value = taskObject[key];
                                return !(value && typeof value === 'object' && !Array.isArray(value));
                            });

                            const duplicatedRootKeys = new Set();
                            Object.entries(taskObject).forEach(([groupKey, groupValue]) => {
                                if (!groupValue || typeof groupValue !== 'object' || Array.isArray(groupValue)) return;

                                Object.keys(groupValue).forEach((fieldKey) => {
                                    if (rootKeys.includes(fieldKey)) {
                                        duplicatedRootKeys.add(fieldKey);
                                    }
                                });
                            });

                            if (duplicatedRootKeys.size > 0) {
                                duplicatedRootKeys.forEach((fieldKey) => {
                                    delete taskObject[fieldKey];
                                });

                                /* console.warn(`${IMPORT_DEBUG_PREFIX} task:root-duplicates-removed`, {
                                    taskId,
                                    removedKeys: Array.from(duplicatedRootKeys)
                                }); */
                            }

                            if (taskId !== null && taskId !== undefined && taskId !== '') {
                                return { [taskId]: taskObject };
                            }

                            return null;
                        }).filter(Boolean);

                        // Diagnostico: detectar campos duplicados en raiz y subtabla para cada task
                        const duplicateDiagnostics = [];
                        sheetData.forEach((taskEntry) => {
                            const taskId = Object.keys(taskEntry)[0];
                            const taskPayload = taskEntry[taskId] || {};

                            const rootKeys = new Set(
                                Object.keys(taskPayload).filter((key) => {
                                    const value = taskPayload[key];
                                    return !(value && typeof value === 'object' && !Array.isArray(value));
                                })
                            );

                            const nestedDuplicateKeys = [];
                            Object.entries(taskPayload).forEach(([groupKey, groupValue]) => {
                                if (!groupValue || typeof groupValue !== 'object' || Array.isArray(groupValue)) return;

                                Object.keys(groupValue).forEach((fieldKey) => {
                                    if (rootKeys.has(fieldKey)) {
                                        nestedDuplicateKeys.push({ fieldKey, groupKey });
                                    }
                                });
                            });

                            if (nestedDuplicateKeys.length > 0) {
                                duplicateDiagnostics.push({ taskId, nestedDuplicateKeys });
                            }
                        });

                        const formattedSheetName = String(sheetName).replace(/\s+/g, '').replace(/[^a-zA-Z]/g, '');
                        if (jsonData.data[formattedSheetName]) {
                            jsonData.data[formattedSheetName] = sheetData;
                            /* console.log(`${IMPORT_DEBUG_PREFIX} sheet:processed`, {
                                sheetName,
                                formattedSheetName,
                                rowsRead: rows.length,
                                tasksMapped: sheetData.length,
                                duplicateTasks: duplicateDiagnostics.length
                            }); */

                            if (duplicateDiagnostics.length > 0) {
                                /* console.warn(`${IMPORT_DEBUG_PREFIX} sheet:duplicates-detected`, {
                                    sheetName,
                                    formattedSheetName,
                                    duplicateDiagnostics: duplicateDiagnostics.slice(0, 10)
                                }); */
                            }

                            if (sheetData.length > 0) {
                                const sampleTaskId = Object.keys(sheetData[0])[0];
                                /* console.log(`${IMPORT_DEBUG_PREFIX} sheet:sample-task`, {
                                    sheetName,
                                    formattedSheetName,
                                    sampleTaskId,
                                    sampleTask: sheetData[0][sampleTaskId]
                                }); */
                            }
                        } else {
                            console.warn(`Unrecognized sheet name: ${sheetName}`);
                            /* console.warn(`${IMPORT_DEBUG_PREFIX} sheet:unrecognized`, {
                                sheetName,
                                formattedSheetName,
                                rowsRead: rows.length,
                                tasksMapped: sheetData.length
                            }); */
                        }
                    };

                    let parsed = false;

                    try {
                        const xlsxWorkbook = XLSX.read(fileBuffer, { type: "array", cellDates: true, raw: false });
                        /* console.log(`${IMPORT_DEBUG_PREFIX} parser:xlsx:start`, {
                            sheetCount: xlsxWorkbook.SheetNames.length,
                            sheetNames: xlsxWorkbook.SheetNames
                        }); */
                        xlsxWorkbook.SheetNames.forEach((sheetName) => {
                            const sheet = xlsxWorkbook.Sheets[sheetName];
                            const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false });
                            processSheetRows(sheetName, rows);
                        });
                        parsed = xlsxWorkbook.SheetNames.length > 0;
                        // console.log(`${IMPORT_DEBUG_PREFIX} parser:xlsx:done`, { parsed });
                    } catch (xlsxError) {
                        console.warn("Primary parser XLSX failed, trying ExcelJS:", xlsxError);
                        /* console.warn(`${IMPORT_DEBUG_PREFIX} parser:xlsx:error`, {
                            message: xlsxError?.message
                        }); */
                    }

                    if (!parsed) {
                        const workbook = new ExcelJS.Workbook();
                        await workbook.xlsx.load(fileBuffer);

                        /* console.log(`${IMPORT_DEBUG_PREFIX} parser:exceljs:start`, {
                            sheetCount: workbook.worksheets.length,
                            sheetNames: workbook.worksheets.map((worksheet) => worksheet.name)
                        }); */

                        workbook.worksheets.forEach((worksheet) => {
                            const maxColumns = worksheet.columnCount;
                            if (maxColumns === 0 || worksheet.rowCount < 3) return;

                            const rows = [];
                            for (let rowNumber = 1; rowNumber <= worksheet.rowCount; rowNumber += 1) {
                                rows.push(getRowValues(worksheet, rowNumber, maxColumns));
                            }

                            processSheetRows(worksheet.name, rows);
                        });

                        // console.log(`${IMPORT_DEBUG_PREFIX} parser:exceljs:done`);
                    }

                    const importSummary = Object.entries(jsonData.data)
                        .filter(([key]) => key !== 'notExportedInformation')
                        .reduce((acc, [key, value]) => {
                            acc[key] = Array.isArray(value) ? value.length : 0;
                            return acc;
                        }, {});

                    const totalMappedTasks = Object.values(importSummary).reduce((sum, count) => sum + count, 0);

                    /* console.log(`${IMPORT_DEBUG_PREFIX} json:summary`, {
                        importSummary,
                        totalMappedTasks
                    }); */

                    const payloadPreview = Object.entries(jsonData.data)
                        .filter(([key, value]) => key !== 'notExportedInformation' && Array.isArray(value) && value.length > 0)
                        .slice(0, 3)
                        .map(([key, value]) => {
                            const firstTaskEntry = value[0] || {};
                            const firstTaskId = Object.keys(firstTaskEntry)[0];
                            return {
                                bucket: key,
                                count: value.length,
                                firstTaskId,
                                firstTaskPayload: firstTaskId ? firstTaskEntry[firstTaskId] : null
                            };
                        });

                    // console.log(`${IMPORT_DEBUG_PREFIX} json:payload-preview`, payloadPreview);
                    // console.log("Generated JSON:", jsonData);
                    setJsonData(jsonData);

                    // Aquí se envía el JSON al backend
                    /* console.log(`${IMPORT_DEBUG_PREFIX} send:before-post`, {
                        totalMappedTasks
                    }); */
                    handleSendJsonToBackend(jsonData);
                } catch (error) {
                    console.error("Error processing the Excel file:", error);
                    /* console.error(`${IMPORT_DEBUG_PREFIX} import:error`, {
                        message: error?.message,
                        stack: error?.stack
                    }); */
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error processing the Excel file. Please verify the format and try again.'
                    });
                }
            };

            reader.onerror = (error) => {
                // console.error(`${IMPORT_DEBUG_PREFIX} reader:error`, error);
            };

            reader.readAsArrayBuffer(file);
        } catch (error) {
            console.error("Error processing the Excel file:", error);
            /* console.error(`${IMPORT_DEBUG_PREFIX} handleImportExcel:error`, {
                message: error?.message,
                stack: error?.stack
            }); */
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            /* console.log(`${IMPORT_DEBUG_PREFIX} file:selected`, {
                name: file.name,
                size: file.size,
                type: file.type
            }); */
            setUploadedFile(file); // Guardar el archivo cargado en el estado
            handleImportExcel(file); // Procesar el archivo

        }
    };

    const handleSendJsonToBackend = async (jsonData) => {
        if (!jsonData) {
            // console.warn(`${IMPORT_DEBUG_PREFIX} send:aborted-no-json`);
            Swal.fire({
                icon: 'error',
                title: 'No Data',
                text: 'No JSON data available to send.'
            });
            return;
        }

        /* console.log(`${IMPORT_DEBUG_PREFIX} send:start`, {
            endpoint: 'workflow/tasks/import'
        }); */

        const sendPreview = Object.entries(jsonData.data || {})
            .filter(([key, value]) => key !== 'notExportedInformation' && Array.isArray(value) && value.length > 0)
            .map(([key, value]) => ({ bucket: key, count: value.length }));

        // console.log(`${IMPORT_DEBUG_PREFIX} send:payload-buckets`, sendPreview);

        // console.log("JSON data to be sent to backend:", JSON.stringify(jsonData, null, 2));

        // Show loading message
        const loadingSwalTimeout = setTimeout(() => {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we send the data.',
                allowOutsideClick: false,
                showCancelButton: true,
                cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        });

        try {
            const response = await new HttpService('workflow/tasks/import').post(jsonData);
            /* console.log(`${IMPORT_DEBUG_PREFIX} send:response`, {
                hasResponse: !!response,
                hasData: !!response?.data,
                success: response?.data?.success
            }); */
            // Close loading message
            clearTimeout(loadingSwalTimeout);
            Swal.close();

            if (response && response.data) {
                const responseData = response.data.data;
                const success = response.data.success;
                const totalTasks = responseData.length;
                let errorMessages = [];
                let successfulTaskIds = new Set(); // Usar un Set para evitar duplicados

                // Regex para extraer IDs de los mensajes de éxito
                const successRegex = /successfully added: \[([\d,\s]+)\]/;

                // Revisar si responseData es un array y procesarlo
                if (Array.isArray(responseData)) {
                    responseData.forEach(subArray => {
                        if (Array.isArray(subArray)) {
                            subArray.forEach(message => {
                                if (typeof message === 'string') {
                                    if (message.startsWith("Error in the task:")) {
                                        errorMessages.push(message);
                                    } else {
                                        const match = message.match(successRegex);
                                        if (match && match[1]) {
                                            // Extraer IDs, limpiar espacios y añadir al Set
                                            match[1].split(',')
                                                .map(id => parseInt(id.trim(), 10))
                                                .filter(id => !isNaN(id))
                                                .forEach(id => successfulTaskIds.add(id));
                                        }
                                    }
                                }
                            });
                        }
                    });
                }

                const successfulIdsArray = Array.from(successfulTaskIds).sort((a, b) => a - b); // Convertir a array ordenado
                console.log("successfulIdsArray ", successfulIdsArray);

                // Función para formatear el mensaje de error (actualizada)
                const formatErrorMessage = (error) => {
                    // Match: "Error in the task: {ID}. In the object: {Path}. In the field: {Field}"
                    const match = error.match(/^(Error in the task: \d+\. In the object: )(.*?)\.( In the field: .*)$/);

                    if (match) {
                        const prefix = match[1];      // "Error in the task: {ID}. In the object: "
                        const objectPath = match[2];  // "airportsNpmEnvDTO" or "SomeObjectDTO"
                        const suffix = match[3];      // ". In the field: {FieldName}"

                        // Split the path and get the last part
                        const pathSegments = objectPath.split('.');
                        const lastSegment = pathSegments[pathSegments.length - 1];

                        // Remove 'DTO' from the end of the last segment
                        const modifiedLastSegment = lastSegment.replace(/DTO$/, ''); // Remove DTO only if it's at the end

                        return `${prefix}${modifiedLastSegment}${suffix}`;
                    }

                    // Si el mensaje no coincide con el formato esperado, devolverlo sin cambios.
                    // Opcionalmente, podrías intentar una limpieza más simple aquí si es necesario.
                    return error;
                };


                // Mostrar mensajes basados en los resultados
                if (errorMessages.length > 0) {
                    //clearTimeout(loadingSwalTimeout);
                    Swal.close();

                    // Retrasar la apertura del nuevo Swal
                    setTimeout(() => {
                        Swal.fire({
                            icon: 'warning', // Indicar que algo requiere atención
                            title: 'Import Status', // Título más neutral
                            html: `
                                <div style="text-align: left; max-height: 400px; overflow-y: auto; padding: 10px;">
                                    ${successfulIdsArray.length > 0 ? `
                                        <h5 style="color: green; margin-bottom: 5px;">Successfully Imported Tasks (${successfulIdsArray.length}):</h5>
                                        <p style="font-size: 0.9em; word-break: break-word;">
                                            <strong>IDs: ${successfulIdsArray.join(', ')}</strong>
                                        </p>
                                        <hr style="margin: 15px 0;" />
                                    ` : ''}
               
                                    <h5 style="color: red; margin-bottom: 5px;">Import Errors (${errorMessages.length}):</h5>
                                    <ul style="list-style-type: none; padding-left: 0; font-size: 0.9em;">
                                        ${errorMessages.map(error => {
                                const formattedError = formatErrorMessage(error); // Formatear el error
                                return `<li style="margin-bottom: 8px; padding: 5px; background-color: #f8d7da; border-left: 3px solid red;">${formattedError}</li>`;
                            }).join('')}
                                    </ul>
                                    <div style="margin-top: 20px; text-align: center;">
                                        <button id="submitAll" class="swal2-confirm swal2-styled" style="background-color: #28a745;">Submit All</button>
                                    </div>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            didOpen: () => {
                                const btn = Swal.getPopup().querySelector('#submitAll');
                                // use onclick property to avoid adding multiple listeners
                                btn.onclick = async () => {
                                    Swal.close();
                                    try {
                                        const res = await new HttpService('data/submitAll').post(successfulIdsArray);
                                        console.log("submitAll response:", res);
                                        if (res && res.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                                            await Swal.fire({
                                                icon: 'success',
                                                title: 'Masive submitted successfully',
                                                html: `The following IDs were successfully imported:<br><strong>${res.data.data.join(', ')}</strong>`
                                            });
                                            // navigate back to overview
                                            navigate('/TODIS-APP/WorkFlow/');
                                        } else if (res && res.data && Array.isArray(res.data.data) && res.data.data.length === 0) {
                                            await Swal.fire({
                                                icon: 'error',
                                                title: 'Error',
                                                html: `The following IDs failed:<br><strong>${res.data.data.join(', ')}</strong>`
                                            });
                                        } else {
                                            await Swal.fire('Error', 'An unexpected error occurred.', 'error');
                                        }
                                    } catch (error) {
                                        await Swal.fire('Error', 'An unexpected error occurred.', 'error');
                                    }
                                };
                            }
                        });
                    }, 5); // Retraso de 500ms
                } else if (success && successfulIdsArray.length > 0) {
                    //clearTimeout(loadingSwalTimeout);
                    Swal.close();

                    // Retrasar la apertura del nuevo Swal
                    setTimeout(() => {

                        Swal.fire({
                            icon: 'success',
                            title: 'Import Successful',
                            html: `
                                <div style="text-align: left; padding: 10px;">
                                    <h5 style="color: green; margin-bottom: 5px;">All Tasks Imported Successfully (${successfulIdsArray.length}):</h5>
                                    <p style="font-size: 0.9em; word-break: break-word;">
                                        <strong>IDs: ${successfulIdsArray.join(', ')}</strong>
                                    </p>
                                    <div style="margin-top: 20px; text-align: center;">
                                        <button id="submitAll" class="swal2-confirm swal2-styled" style="background-color: #28a745;">Submit All</button>
                                    </div>
                                </div>
                            `,
                            confirmButtonText: 'OK',
                            didOpen: () => {
                                const btn = Swal.getPopup().querySelector('#submitAll');
                                btn.onclick = async () => {
                                    Swal.close();
                                    try {
                                        const res = await new HttpService('data/submitAll').post(successfulIdsArray);
                                        console.log("submitAll response:", res);
                                        if (res && res.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                                            await Swal.fire({
                                                icon: 'success',
                                                title: 'Masive submitted successfully',
                                                html: `The following IDs were successfully submitted:<br><strong>${res.data.data.join(', ')}</strong>`
                                            });
                                            navigate('/TODIS-APP/WorkFlow/');
                                        } else if (res && res.data && Array.isArray(res.data.data) && res.data.data.length === 0) {
                                            await Swal.fire({
                                                icon: 'error',
                                                title: 'Error',
                                                html: `The following IDs failed:<br><strong>${res.data.data.join(', ')}</strong>`
                                            });
                                        } else {
                                            await Swal.fire('Error', 'An unexpected error occurred.', 'error');
                                        }
                                    } catch (error) {
                                        await Swal.fire('Error', 'An unexpected error occurred.', 'error');
                                    }
                                };
                            }
                        });
                    }, 5);
                } else if (success) {
                    // Success es true, pero no se detectaron IDs exitosos (caso raro)
                    Swal.close()
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: response.data.message || 'Data processed successfully, but no specific task IDs were confirmed.'
                    });
                } else {
                    // Fallo general (success es false y no hay errores específicos)
                    Swal.close()
                    Swal.fire({
                        icon: 'error',
                        title: 'Import Failed',
                        text: response.data.message || 'Failed to import data. Please check the file or contact support.'
                    });
                }

            } else {
                // La respuesta no tiene el formato esperado
                // console.warn(`${IMPORT_DEBUG_PREFIX} send:invalid-response`, response);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Received an invalid response from the server.'
                });
            }
        } catch (error) {
            // Close loading message in case of error
            Swal.close();

            console.error("Error sending JSON to backend:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while sending data to the backend.'
            });
        }
    };

    // Creamos una referencia para el input file oculto
    const fileInputRef = useRef(null);
    // Al pulsar Import Data, simulamos el click en el input file
    const handleImportDataClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // Función para obtener los años disponibles de las tareas
    const getAvailableYears = () => {
        const years = new Set();
        const allTasks = [...tasksPending, ...tasksWorking, ...tasksDone];
        allTasks.forEach(task => {
            const taskDate = task.requestDetailsDTO.validFor;
            if (taskDate) {
                const year = taskDate.split('-')[0];
                years.add(year);
            }
        });
        return Array.from(years).sort((a, b) => b - a); // Ordenar de mayor a menor
    };

    // Función para filtrar tareas por año
    const getFilteredTasks = (tasks) => {
        if (!filterDate) {
            return tasks;
        }
        return tasks.filter(task => {
            const taskDate = task.requestDetailsDTO.validFor;
            const taskYear = taskDate ? taskDate.split('-')[0] : '';
            return taskYear === filterDate;
        });
    };

    // Función para limpiar el filtro
    const handleClearFilter = () => {
        setFilterDate('');
    };

    const isAdmin = permissions.some(item => item.id == 2)
    return (
        <Col xxl={isAdmin ? 12 : 9} xl={isAdmin ? 12 : 9} lg={isAdmin ? 12 : 9} md={isAdmin ? 12 : 12} sm={isAdmin ? 12 : 12}>
            <Container fluid className="todis-form-wrapper p-4" style={{ height: '95%' }}>
                <Col lg={12} className="pb-3 text-end">
                    {taskId !== null && taskId !== "null" && (<TODIS_BTN_SECUNDARY title="Unmark Task" type="submit" onclick={() => resetTaskId()} />)}
                </Col>

                <Row className="pb-3">
                    <Col lg={6}>
                        {/* Botones globales */}
                        <TODIS_SECONDARY_BTN
                            title="Select All"
                            onclick={handleSelectAll}
                            className="me-2"
                        />
                        <TODIS_SECONDARY_BTN
                            title="Deselect All"
                            onclick={handleDeselectAll}
                            className="me-2"
                        />
                    </Col>
                    <Col lg={6} className="text-end">
                        {/* Filtro por año */}
                        <div className="d-flex justify-content-end align-items-center gap-2">
                            <label htmlFor="filterYear" className="mb-0 fw-bold" style={{ fontSize: "0.95rem" }}>Filter by Year:</label>
                            <select
                                id="filterYear"
                                value={filterDate}
                                onChange={(e) => setFilterDate(e.target.value)}
                                className="form-select"
                                style={{
                                    maxWidth: "150px",
                                    padding: "0.55rem 0.75rem",
                                    borderColor: "#004494",
                                    borderRadius: "0.375rem",
                                    fontSize: "0.95rem",
                                    fontWeight: "500",
                                    backgroundColor: "#f8f9fa",
                                    color: "#004494",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease"
                                }}
                            >
                                <option value="" style={{ color: "#6c757d" }}>-- Select Year --</option>
                                {getAvailableYears().map(year => (
                                    <option key={year} value={year} style={{ color: "#004494" }}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                            {filterDate && (
                                <TODIS_SECONDARY_BTN
                                    title="Clear Filter"
                                    onclick={handleClearFilter}
                                    className="ms-2"
                                />
                            )}
                        </div>
                    </Col>
                </Row>


                <Row className="pb-3">
                    {/* <Col lg={3} className="text-end">
                        <TODIS_SECONDARY_BTN
                            title="Download Template"
                            iconName="template"
                            onclick={handleDownloadTemplateClick}
                            className="w-100"
                        />
                    </Col> */}
                    <Col lg={3} className="text-end">
                        <TODIS_SECONDARY_BTN
                            title="Import Data"
                            iconName="upload"
                            onclick={handleImportDataClick}
                            className="w-100"
                        />
                    </Col>
                    <Col lg={3} className="pb-3 text-end">
                        <TODIS_SECONDARY_BTN
                            title="Export Data"
                            iconName="download"
                            onclick={handleExportDataClick}
                            className="w-100"
                        />
                    </Col>
                </Row>

                {/* Input file oculto que se activará mediante la referencia */}
                <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={(e) => {
                        handleFileChange(e);
                        e.target.value = null; // Reset the input value to allow re-selection of the same file
                    }}
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                />

                <Row className=" pb-3">
                    <Col lg={4}>
                        <Row>
                            <Col lg={12}>
                                <div className={`${style.containerNotification} ${style.colorContainerPending} d-flex`}>
                                    <div className={`${style.notificationAvatar} ${style.countPending} fw-bold`}>
                                        {tasksPending.length}
                                    </div>
                                    <h5 className={style.textNotify}>Pending</h5>
                                </div>
                            </Col>
                            <Col lg={12} className="d-flex justify-content-start mb-2 mt-2">
                                <TODIS_SECONDARY_BTN
                                    title="Select All"
                                    onclick={handleSelectAllPending}
                                    className="me-2"
                                />
                                <TODIS_SECONDARY_BTN
                                    title="Deselect All"
                                    onclick={handleDeselectAllPending}
                                    className="me-2"
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={4}>
                        <Row>
                            <Col lg={12}>
                                <div className={`${style.containerNotification} ${style.colorContainerWorking} ${"d-flex"}`}>
                                    <div className={`${style.notificationAvatar} ${style.countWorking} ${"fw-bold"}`}>{tasksWorking.length}</div>
                                    <h5 className={style.textNotify}>Working On</h5>
                                </div>
                            </Col>
                            <Col lg={12} className="d-flex justify-content-start mb-2 mt-2">
                                <TODIS_SECONDARY_BTN
                                    title="Select All"
                                    onclick={handleSelectAllWorking}
                                    className="me-2"
                                />
                                <TODIS_SECONDARY_BTN
                                    title="Deselect All"
                                    onclick={handleDeselectAllWorking}
                                    className="me-2"
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={4}>
                        <Row>
                            <Col lg={12}>
                                <div className={`${style.containerNotification} ${style.colorContainerDone} ${"d-flex"}`}>
                                    <div className={`${style.notificationAvatar} ${style.countDone} ${"fw-bold"}`}>{tasksDone.length}</div>
                                    <h5 className={style.textNotify}>Done</h5>
                                </div>
                            </Col>

                        </Row>
                    </Col>

                    <Row className="pb-3">
                        {/* PENDING */}
                        <Col lg={4}>
                            <Row className="pb-3 px-3" style={{ overflow: "auto", maxHeight: "715px" }}>
                                {
                                    !tasksNotFound && response ?
                                        (getFilteredTasks(tasksPending).map((task) => (
                                            <Col lg={12} className={`${style.dataTask} ${"mt-4"} ${String(task.id) === taskId ? style.borderTaskPendingNot : style.borderTaskPending}`} key={task.id} ref={String(task.id) === taskId ? scrollRef : null}>
                                                <Container className="pe-0">
                                                    <Row className="selectable-task" style={{ cursor: "pointer" }}>
                                                        {/* Checkbox para seleccionar o deseleccionar el Task */}
                                                        <Col lg={1} className="align-items-start pt-2">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={selectedTasks.some(pair => pair.taskId === task.id && pair.requestId === task.requestId)}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleCheckboxChange(task.id, task.requestId);
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col lg={11} onClick={() => changeWorkingOn(task)}>
                                                            <h6 className="w-100 text-right text-secondary mb-0" style={{ fontSize: "0.8rem", textAlign: "end" }} >{task.createdAt}</h6>
                                                            <h6 className="w-100 text-right text-secondary mb-0" style={{ fontSize: "1rem", textAlign: "end" }}>Valid For: {task.requestDetailsDTO.validFor}</h6>
                                                            <h5 className="fw-bold" style={{ paddingRight: "85px" }}>{getProjectTitle(task.requestDetailsDTO.transportType, task.requestDetailsDTO.regionalPartnar, task.requestDetailsDTO.projectType)}</h5>
                                                            <Row>
                                                                <Col lg={12}>
                                                                    <span><MdGrid3X3 size="18" color="#004494" /> Requeste ID: {task.requestId}</span>
                                                                    <br />
                                                                    <span><MdGrid3X3 size="18" color="#004494" /> Task ID: {task.id}</span>
                                                                </Col>
                                                                <Col lg={12} className={style.textEllipsis}>
                                                                    <span title={task.name}><FaDatabase size="18" className="me-1" color="#004494" /> {/*{task.name}*/} {tabFormName[task.requestDetailsDTO.formType]}</span>
                                                                </Col>
                                                                {/* <Col lg={2} style={{ textAlign: "end" }}>
                                                                    <span style={{ paddingRight: "8px", fontSize: "13px" }}>Valid For <h5 style={{ display: "inline-block", fontSize: "14px", textAlign: "end" }}>{task.requestDetailsDTO.validFor}</h5></span>
                                                                </Col> */}
                                                                {(task.requestDetailsDTO.transportType == 'Roads' || task.requestDetailsDTO.transportType == 'Railways' || task.requestDetailsDTO.transportType == 'Inland waterways') && task.requestDetailsDTO.startNode && task.requestDetailsDTO.endNode && (
                                                                    <>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 1:</strong> {task.requestDetailsDTO.startNode}</span>
                                                                        </Col>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 2:</strong> {task.requestDetailsDTO.endNode}</span>
                                                                        </Col>
                                                                    </>
                                                                )}
                                                                {task.requestDetailsDTO.transportType !== 'Roads' && task.requestDetailsDTO.transportType !== 'Railways' && task.requestDetailsDTO.transportType !== 'Inland waterways' && task.requestDetailsDTO.startNode && task.requestDetailsDTO.endNode && (
                                                                    <>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node Name:</strong> {task.requestDetailsDTO.startNode}</span>
                                                                        </Col>
                                                                    </>
                                                                )}
                                                                {task.requestDetailsDTO.transportType == "EU-ACQUIS" && (
                                                                    <Col lg={2} className="w-auto">
                                                                        <span><strong>Celex Number:</strong> {task.requestDetailsDTO.celexNumber}</span>
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>)))
                                        : tasksNotFound ?
                                            <div className="h-100 d-flex justify-content-center align-items-center">
                                                <div style={{ textAlign: "center" }}>
                                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                                    <h3 className="">Task Not found </h3>
                                                </div>
                                            </div>
                                            :
                                            // loading tasks 
                                            ([...Array(5)].map((task, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                                <Row>
                                                    <Col lg={12}>
                                                        <Placeholder as="h6" animation="glow" style={{ textAlign: "end" }}><Placeholder xs={5} size="sm" /></Placeholder>
                                                        <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                                        <Row>
                                                            <Col lg={1} >
                                                                <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                            </Col>
                                                            <Col lg={11} >
                                                                <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Container></Col>)))
                                }
                            </Row>
                        </Col>

                        {/* WORKING ON */}
                        <Col lg={4}>
                            <Row className="pb-3 px-3" style={{ overflow: "auto", maxHeight: "715px" }}>
                                {
                                    !tasksNotFound && response ?
                                        (getFilteredTasks(tasksWorking).map((task, index) => (
                                            <Col lg={12} className={`${style.dataTask} ${"mt-4"} ${String(task.id) === taskId ? style.borderTaskWorkingNot : style.borderTaskWorking}`} key={index} ref={String(task.id) === taskId ? scrollRef : null}>
                                                <Container className="pe-0">
                                                    <Row className="selectable-task" style={{ cursor: "pointer" }}>
                                                        {/* Checkbox */}
                                                        <Col lg={1} className="align-items-start pt-2">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={selectedTasks.some(pair => pair.taskId === task.id && pair.requestId === task.requestId)}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleCheckboxChange(task.id, task.requestId);
                                                                }}
                                                            />
                                                        </Col>

                                                        <Col lg={11} onClick={() => navigate("/TODIS-APP/WorkFlow/task/" + task.id)}>
                                                            <h6 className="w-100 text-right text-secondary mb-0" style={{ fontSize: "0.8rem", textAlign: "end" }} >{task.createdAt}</h6>
                                                            <h6 className="w-100 text-right text-secondary mb-0" style={{ fontSize: "1rem", textAlign: "end" }}>Valid For: {task.requestDetailsDTO.validFor}</h6>

                                                            <h5 className="fw-bold" style={{ paddingRight: "85px" }}>{getProjectTitle(task.requestDetailsDTO.transportType, task.requestDetailsDTO.regionalPartnar, task.requestDetailsDTO.projectType)}</h5>
                                                            {/*                                                         <h5 className="fw-bold" style={{paddingRight: "85px"}}>{task.name}</h5>
*/}                                                        <Row>
                                                                <Col lg={12}>
                                                                    <span><MdGrid3X3 size="18" color="#004494" /> Request ID: {task.requestId}</span>
                                                                    <br />
                                                                    <span><MdGrid3X3 size="18" color="#004494" /> Task ID: {task.id}</span>
                                                                </Col>
                                                                <Col lg={12} className={style.textEllipsis}>
                                                                    <span title={task.name}><FaDatabase size="18" className="me-1" color="#004494" /> {/*{task.name}*/} {tabFormName[task.requestDetailsDTO.formType]}</span>
                                                                </Col>
                                                                {(task.requestDetailsDTO.transportType == 'Roads' || task.requestDetailsDTO.transportType == 'Railways' || task.requestDetailsDTO.transportType == 'Inland waterways') && task.requestDetailsDTO.startNode && task.requestDetailsDTO.endNode && (
                                                                    <>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 1:</strong> {task.requestDetailsDTO.startNode}</span>
                                                                        </Col>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 2:</strong> {task.requestDetailsDTO.endNode}</span>
                                                                        </Col>
                                                                    </>
                                                                )}
                                                                {task.requestDetailsDTO.transportType !== 'Roads' && task.requestDetailsDTO.transportType !== 'Railways' && task.requestDetailsDTO.transportType !== 'Inland waterways' && task.requestDetailsDTO.startNode && task.requestDetailsDTO.endNode && (
                                                                    <>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node Name:</strong> {task.requestDetailsDTO.startNode}</span>
                                                                        </Col>
                                                                    </>
                                                                )}
                                                                {task.requestDetailsDTO.transportType == "EU-ACQUIS" && (
                                                                    <Col lg={2} className="w-auto">
                                                                        <span><strong>Celex Number:</strong> {task.requestDetailsDTO.celexNumber}</span>
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>)))
                                        : tasksNotFound ?
                                            <div className="h-100 d-flex justify-content-center align-items-center">
                                                <div style={{ textAlign: "center" }}>
                                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                                    <h3 className="">Task Not found </h3>
                                                </div>
                                            </div>
                                            :
                                            // loading tasks 
                                            ([...Array(5)].map((task, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                                <Row>
                                                    <Col lg={12}>
                                                        <Placeholder as="h6" animation="glow" style={{ textAlign: "end" }}><Placeholder xs={5} size="sm" /></Placeholder>
                                                        <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                                        <Row>
                                                            <Col lg={1} >
                                                                <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                            </Col>
                                                            <Col lg={11} >
                                                                <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Container></Col>)))
                                }
                            </Row>
                        </Col>

                        {/* DONE */}
                        <Col lg={4}>
                            <Row className="pb-3 px-3" style={{ overflow: "auto", maxHeight: "715px" }}>
                                {
                                    !tasksNotFound && response ?
                                        (getFilteredTasks(tasksDone).map((task, index) => (
                                            <Col lg={12} className={`${style.dataTask} ${"mt-4"} ${String(task.id) === taskId ? style.borderTaskDoneNot : style.borderTaskDone}`} key={index} ref={String(task.id) === taskId ? scrollRef : null}>
                                                <Container className="pe-0">
                                                    <Row className="selectable-task" style={{ cursor: "pointer" }}>
                                                        <Col lg={12} onClick={() => navigate("/TODIS-APP/WorkFlow/task/" + task.id)}>
                                                            <h6 className="w-100 text-right text-secondary mb-0" style={{ fontSize: "0.8rem", textAlign: "end" }}>{task.createdAt}</h6>

                                                            {/* Mover "Valid For" fuera del div y colocarlo aquí */}
                                                            <h6 className="w-100 text-right text-secondary mb-0" style={{ fontSize: "1rem", textAlign: "end" }}>Valid For: {task.requestDetailsDTO.validFor}</h6>

                                                            {/* Mantener el título del proyecto en una línea separada */}
                                                            <h5 className="fw-bold" style={{ paddingRight: "85px" }}>
                                                                {getProjectTitle(task.requestDetailsDTO.transportType, task.requestDetailsDTO.regionalPartnar, task.requestDetailsDTO.projectType)}
                                                            </h5>

                                                            <Row>
                                                                <Col lg={12}>
                                                                    <span><MdGrid3X3 size="18" color="#004494" /> Request ID: {task.requestId}</span>
                                                                    <br />
                                                                    <span><MdGrid3X3 size="18" color="#004494" /> Task ID: {task.id}</span>
                                                                </Col>
                                                                <Col lg={12} className={style.textEllipsis}>
                                                                    <span title={task.name}><FaDatabase size="18" className="me-1" color="#004494" /> {/*{task.name}*/} {tabFormName[task.requestDetailsDTO.formType]}</span>
                                                                </Col>
                                                                {(task.requestDetailsDTO.transportType == 'Roads' || task.requestDetailsDTO.transportType == 'Railways' || task.requestDetailsDTO.transportType == 'Inland waterways') && task.requestDetailsDTO.startNode && task.requestDetailsDTO.endNode && (
                                                                    <>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 1:</strong> {task.requestDetailsDTO.startNode}</span>
                                                                        </Col>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node 2:</strong> {task.requestDetailsDTO.endNode}</span>
                                                                        </Col>
                                                                    </>
                                                                )}
                                                                {task.requestDetailsDTO.transportType !== 'Roads' && task.requestDetailsDTO.transportType !== 'Railways' && task.requestDetailsDTO.transportType !== 'Inland waterways' && task.requestDetailsDTO.startNode && task.requestDetailsDTO.endNode && (
                                                                    <>
                                                                        <Col lg={2} className="w-auto">
                                                                            <span><MdLocationOn size="20" color="#004494" /><strong>Node Name:</strong> {task.requestDetailsDTO.startNode}</span>
                                                                        </Col>
                                                                    </>
                                                                )}
                                                                {task.requestDetailsDTO.transportType == "EU-ACQUIS" && (
                                                                    <Col lg={2} className="w-auto">
                                                                        <span><strong>Celex Number:</strong> {task.requestDetailsDTO.celexNumber}</span>
                                                                    </Col>
                                                                )}
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Col>)))
                                        : tasksNotFound ?
                                            <div className="h-100 d-flex justify-content-center align-items-center">
                                                <div style={{ textAlign: "center" }}>
                                                    <BsCloudSlashFill fontSize={100} color="#000000" />
                                                    <h3 className="">Task Not found </h3>
                                                </div>
                                            </div>
                                            :
                                            // loading tasks 
                                            ([...Array(5)].map((task, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                                <Row>
                                                    <Col lg={12}>
                                                        <Placeholder as="h6" animation="glow" style={{ textAlign: "end" }}><Placeholder xs={5} size="sm" /></Placeholder>
                                                        <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                                        <Row>
                                                            <Col lg={1} >
                                                                <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                            </Col>
                                                            <Col lg={11} >
                                                                <Placeholder as="h6" animation="glow"><Placeholder xs={8} size="sm" /></Placeholder>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Container></Col>)))
                                }
                            </Row>
                        </Col>
                    </Row>
                </Row>
            </Container>
        </Col>
    );
}

export default Tasks;